import { render, staticRenderFns } from "./OperationManageStudents.vue?vue&type=template&id=34d0613c&scoped=true"
import script from "./OperationManageStudents.vue?vue&type=script&lang=js"
export * from "./OperationManageStudents.vue?vue&type=script&lang=js"
import style0 from "./OperationManageStudents.vue?vue&type=style&index=0&id=34d0613c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d0613c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d0613c')) {
      api.createRecord('34d0613c', component.options)
    } else {
      api.reload('34d0613c', component.options)
    }
    module.hot.accept("./OperationManageStudents.vue?vue&type=template&id=34d0613c&scoped=true", function () {
      api.rerender('34d0613c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/managePackages/components/OperationManageStudents.vue"
export default component.exports